// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1n1C_","left":"InfoRow_left__3N0H-"};